<template>
  <global-layout v-if="isShowPage">
    <page-header :breadcrumb="breadcrumb"></page-header>
    <transition name="page-toggle">
      <router-view/>
    </transition>
  </global-layout>
</template>
<script>

import GlobalLayout from './GlobalLayout'
import PageHeader from '../components/page/PageHeader'
export default {
  name: 'MenuView',
  components: {
    GlobalLayout,
    PageHeader
  },
  data () {
    return {
      breadcrumb: [],
      isShowPage: true
    }
  },
  // beforeMount() {
  //   this.getBaseDict()
  // },
  mounted () {
    this.getBreadcrumb()
  },
  watch: {
    '$route' () {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb () {
      const matched = this.$route.matched
        .filter(r => r.name && r.name !== '后台管理')
        .map(r => ({ name: r.name, path: r.path, redirect: r.redirect }))
      // 编辑场景下把 "新增供应商" 改成 "编辑供应商"
      if (this.$route.path === '/gysmanagement/add' && this.$route.query.id) {
        matched.forEach(r => {
          if (r.name === '新增供应商') r.name = '编辑供应商'
        })
      }
      const meta = this.$route.meta
      if (meta && meta.parentName) {
        this.breadcrumb = [
          { name: meta.parentName, redirect: meta.parentPath },
          ...matched
        ]
      } else {
        this.breadcrumb = matched
      }
    }
    // async getBaseDict() {
    //   const res = await this.$axios.post('/api/common/currentTerm.do')
    //   const base = {
    //     schoolYear: res.data.XN,
    //     semester: res.data.XQ
    //   }
    //   this.$store.commit('setBaseDict',base)
    //   this.isShowPage = true
    //   // console.log(res)
    //   // this.$router.push('/teaching/manage')
    // }
  }
}
</script>
